// https://github.com/ChristoPy/countries-phone-masks/blob/main/src/countries.json

export const COUNTRIES = [
  {
    "name": "Afghanistan",
    "code": "93",
    "iso": "AF",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Aland Islands",
    "code": "358",
    "iso": "AX",
    "mask": "(###) ###-##-##",
    "pa": 3
  },
  {
    "name": "Albania",
    "code": "355",
    "iso": "AL",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Algeria",
    "code": "213",
    "iso": "DZ",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "American Samoa",
    "code": "1",
    "iso": "AS",
    "mask": "(684) ###-####",
    "pa": 3
  },
  {
    "name": "Andorra",
    "code": "376",
    "iso": "AD",
    "mask": "###-###",
    "pa": 3
  },
  {
    "name": "Angola",
    "code": "244",
    "iso": "AO",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Anguilla",
    "code": "1",
    "iso": "AI",
    "mask": "(264) ###-####",
    "pa": 3
  },
  {
    "name": "Antarctica",
    "code": "672",
    "iso": "AQ",
    "mask": "1##-###",
    "pa": 3
  },
  {
    "name": "Antigua and Barbuda",
    "code": "1",
    "iso": "AG",
    "mask": "(268) ###-####",
    "pa": 3
  },
  {
    "name": "Argentina",
    "code": "54",
    "iso": "AR",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Armenia",
    "code": "374",
    "iso": "AM",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Aruba",
    "code": "297",
    "iso": "AW",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Australia",
    "code": "61",
    "iso": "AU",
    "mask": "#-####-####",
    "pa": 1
  },
  {
    "name": "Austria",
    "code": "43",
    "iso": "AT",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Azerbaijan",
    "code": "994",
    "iso": "AZ",
    "mask": "##-###-##-##",
    "pa": 2
  },
  {
    "name": "Bahamas",
    "code": "1",
    "iso": "BS",
    "mask": "(242) ###-####",
    "pa": 3
  },
  {
    "name": "Bahrain",
    "code": "973",
    "iso": "BH",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Bangladesh",
    "code": "880",
    "iso": "BD",
    "mask": "1###-######",
    "pa": 4
  },
  {
    "name": "Barbados",
    "code": "1",
    "iso": "BB",
    "mask": "(246) ###-####",
    "pa": 3
  },
  {
    "name": "Belarus",
    "code": "375",
    "iso": "BY",
    "mask": "(##) ###-##-##",
    "pa": 2
  },
  {
    "name": "Belgium",
    "code": "32",
    "iso": "BE",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Belize",
    "code": "501",
    "iso": "BZ",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Benin",
    "code": "229",
    "iso": "BJ",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Bermuda",
    "code": "1",
    "iso": "BM",
    "mask": "(441) ###-####",
    "pa": 3
  },
  {
    "name": "Bhutan",
    "code": "975",
    "iso": "BT",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Bolivia",
    "code": "591",
    "iso": "BO",
    "mask": "#-###-####",
    "pa": 1
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "387",
    "iso": "BA",
    "mask": "##-#####",
    "pa": 2
  },
  {
    "name": "Botswana",
    "code": "267",
    "iso": "BW",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Brazil",
    "code": "55",
    "iso": "BR",
    "mask": "(##) #####-####",
    "pa": 2
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "246",
    "iso": "IO",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Brunei Darussalam",
    "code": "673",
    "iso": "BN",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Bulgaria",
    "code": "359",
    "iso": "BG",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Burkina Faso",
    "code": "226",
    "iso": "BF",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Burundi",
    "code": "257",
    "iso": "BI",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Cambodia",
    "code": "855",
    "iso": "KH",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Cameroon",
    "code": "237",
    "iso": "CM",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Canada",
    "code": "1",
    "iso": "CA",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Cape Verde",
    "code": "238",
    "iso": "CV",
    "mask": "(###) ##-##",
    "pa": 3
  },
  {
    "name": "Cayman Islands",
    "code": "1",
    "iso": "KY",
    "mask": "(345) ###-####",
    "pa": 3
  },
  {
    "name": "Central African Republic",
    "code": "236",
    "iso": "CF",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Chad",
    "code": "235",
    "iso": "TD",
    "mask": "##-##-##-##",
    "pa": 2
  },
  {
    "name": "Chile",
    "code": "56",
    "iso": "CL",
    "mask": "#-####-####",
    "pa": 1
  },
  {
    "name": "China",
    "code": "86",
    "iso": "CN",
    "mask": "(###) ####-####",
    "pa": 3
  },
  {
    "name": "Christmas Island",
    "code": "61",
    "iso": "CX",
    "mask": "#-####-####",
    "pa": 1
  },
  {
    "name": "Cocos (Keeling) Islands",
    "code": "61",
    "iso": "CC",
    "mask": "#-####-####",
    "pa": 1
  },
  {
    "name": "Colombia",
    "code": "57",
    "iso": "CO",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Comoros",
    "code": "269",
    "iso": "KM",
    "mask": "##-#####",
    "pa": 2
  },
  {
    "name": "Congo",
    "code": "242",
    "iso": "CG",
    "mask": "##-#####",
    "pa": 2
  },
  {
    "name": "Cook Islands",
    "code": "682",
    "iso": "CK",
    "mask": "##-###",
    "pa": 2
  },
  {
    "name": "Costa Rica",
    "code": "506",
    "iso": "CR",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Croatia",
    "code": "385",
    "iso": "HR",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Cuba",
    "code": "53",
    "iso": "CU",
    "mask": "#-###-####",
    "pa": 1
  },
  {
    "name": "Cyprus",
    "code": "357",
    "iso": "CY",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Czech Republic",
    "code": "420",
    "iso": "CZ",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Democratic Republic of the Congo",
    "code": "243",
    "iso": "CD",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Denmark",
    "code": "45",
    "iso": "DK",
    "mask": "##-##-##-##",
    "pa": 2
  },
  {
    "name": "Djibouti",
    "code": "253",
    "iso": "DJ",
    "mask": "##-##-##-##",
    "pa": 2
  },
  {
    "name": "Dominica",
    "code": "1",
    "iso": "DM",
    "mask": "(767) ###-####",
    "pa": 3
  },
  {
    "name": "Dominican Republic",
    "code": "1",
    "iso": "DO",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Ecuador",
    "code": "593",
    "iso": "EC",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Egypt",
    "code": "20",
    "iso": "EG",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "El Salvador",
    "code": "503",
    "iso": "SV",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Equatorial Guinea",
    "code": "240",
    "iso": "GQ",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Eritrea",
    "code": "291",
    "iso": "ER",
    "mask": "#-###-###",
    "pa": 1
  },
  {
    "name": "Estonia",
    "code": "372",
    "iso": "EE",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Eswatini",
    "code": "268",
    "iso": "SZ",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Ethiopia",
    "code": "251",
    "iso": "ET",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "code": "500",
    "iso": "FK",
    "mask": "#####",
    "pa": 1
  },
  {
    "name": "Faroe Islands",
    "code": "298",
    "iso": "FO",
    "mask": "## ## ##",
    "pa": 2
  },
  {
    "name": "Fiji",
    "code": "679",
    "iso": "FJ",
    "mask": "##-#####",
    "pa": 2
  },
  {
    "name": "Finland",
    "code": "358",
    "iso": "FI",
    "mask": "## ### ####",
    "pa": 2
  },
  {
    "name": "France",
    "code": "33",
    "iso": "FR",
    "mask": "# ## ## ## ##",
    "pa": 1
  },
  {
    "name": "French Guiana",
    "code": "594",
    "iso": "GF",
    "mask": "### ## ## ##",
    "pa": 3
  },
  {
    "name": "French Polynesia",
    "code": "689",
    "iso": "PF",
    "mask": "## ## ## ##",
    "pa": 2
  },
  {
    "name": "Gabon",
    "code": "241",
    "iso": "GA",
    "mask": "# ## ## ##",
    "pa": 1
  },
  {
    "name": "Gambia",
    "code": "220",
    "iso": "GM",
    "mask": "### ####",
    "pa": 3
  },
  {
    "name": "Georgia",
    "code": "995",
    "iso": "GE",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Germany",
    "code": "49",
    "iso": "DE",
    "mask": "(###) ####-####",
    "pa": 3
  },
  {
    "name": "Ghana",
    "code": "233",
    "iso": "GH",
    "mask": "03# ### ####",
    "pa": 3
  },
  {
    "name": "Gibraltar",
    "code": "350",
    "iso": "GI",
    "mask": "###-#####",
    "pa": 3
  },
  {
    "name": "Greece",
    "code": "30",
    "iso": "GR",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Greenland",
    "code": "299",
    "iso": "GL",
    "mask": "##-##-##",
    "pa": 2
  },
  {
    "name": "Grenada",
    "code": "1",
    "iso": "GD",
    "mask": "(473) ###-####",
    "pa": 3
  },
  {
    "name": "Guadeloupe",
    "code": "590",
    "iso": "GP",
    "mask": "### ## ## ##",
    "pa": 3
  },
  {
    "name": "Guam",
    "code": "1",
    "iso": "GU",
    "mask": "671 ### ####",
    "pa": 3
  },
  {
    "name": "Guatemala",
    "code": "502",
    "iso": "GT",
    "mask": "#-###-####",
    "pa": 1
  },
  {
    "name": "Guernsey",
    "code": "44",
    "iso": "GG",
    "mask": "(####) ######",
    "pa": 4
  },
  {
    "name": "Guinea",
    "code": "224",
    "iso": "GN",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Guinea-Bissau",
    "code": "245",
    "iso": "GW",
    "mask": "#-######",
    "pa": 1
  },
  {
    "name": "Guyana",
    "code": "592",
    "iso": "GY",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Haiti",
    "code": "509",
    "iso": "HT",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Holy See (Vatican City State)",
    "code": "39",
    "iso": "VA",
    "mask": "06 698#####",
    "pa": 2
  },
  {
    "name": "Honduras",
    "code": "504",
    "iso": "HN",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Hong Kong",
    "code": "852",
    "iso": "HK",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Hungary",
    "code": "36",
    "iso": "HU",
    "mask": "## ### ####",
    "pa": 2
  },
  {
    "name": "Iceland",
    "code": "354",
    "iso": "IS",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "India",
    "code": "91",
    "iso": "IN",
    "mask": "(####) ###-###",
    "pa": 4
  },
  {
    "name": "Indonesia",
    "code": "62",
    "iso": "ID",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Iran",
    "code": "98",
    "iso": "IR",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Iraq",
    "code": "964",
    "iso": "IQ",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Ireland",
    "code": "353",
    "iso": "IE",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Isle of Man",
    "code": "44",
    "iso": "IM",
    "mask": "(####) ######",
    "pa": 4
  },
  {
    "name": "Israel",
    "code": "972",
    "iso": "IL",
    "mask": "#-###-####",
    "pa": 1
  },
  {
    "name": "Italy",
    "code": "39",
    "iso": "IT",
    "mask": "(###) ####-###",
    "pa": 3
  },
  {
    "name": "Ivory Coast / Cote d'Ivoire",
    "code": "225",
    "iso": "CI",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Jamaica",
    "code": "1",
    "iso": "JM",
    "mask": "(876) ###-####",
    "pa": 3
  },
  {
    "name": "Japan",
    "code": "81",
    "iso": "JP",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Jersey",
    "code": "44",
    "iso": "JE",
    "mask": "(####) ####-######",
    "pa": 4
  },
  {
    "name": "Jordan",
    "code": "962",
    "iso": "JO",
    "mask": "#-####-####",
    "pa": 1
  },
  {
    "name": "Kazakhstan",
    "code": "77",
    "iso": "KZ",
    "mask": "(###) ### ## ##",
    "pa": 3
  },
  {
    "name": "Kenya",
    "code": "254",
    "iso": "KE",
    "mask": "###-######",
    "pa": 3
  },
  {
    "name": "Kiribati",
    "code": "686",
    "iso": "KI",
    "mask": "##-###",
    "pa": 2
  },
  {
    "name": "Korea, Democratic People's Republic of Korea",
    "code": "850",
    "iso": "KP",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Korea, Republic of South Korea",
    "code": "82",
    "iso": "KR",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Kosovo",
    "code": "383",
    "iso": "XK",
    "mask": "###-###-###",
    "pa": 3
  },
  {
    "name": "Kuwait",
    "code": "965",
    "iso": "KW",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Kyrgyzstan",
    "code": "996",
    "iso": "KG",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Laos",
    "code": "856",
    "iso": "LA",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Latvia",
    "code": "371",
    "iso": "LV",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Lebanon",
    "code": "961",
    "iso": "LB",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Lesotho",
    "code": "266",
    "iso": "LS",
    "mask": "#-###-####",
    "pa": 1
  },
  {
    "name": "Liberia",
    "code": "231",
    "iso": "LR",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Libya",
    "code": "218",
    "iso": "LY",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Liechtenstein",
    "code": "423",
    "iso": "LI",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Lithuania",
    "code": "370",
    "iso": "LT",
    "mask": "(###) ##-###",
    "pa": 3
  },
  {
    "name": "Luxembourg",
    "code": "352",
    "iso": "LU",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Macau",
    "code": "853",
    "iso": "MO",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Madagascar",
    "code": "261",
    "iso": "MG",
    "mask": "##-##-#####",
    "pa": 2
  },
  {
    "name": "Malawi",
    "code": "265",
    "iso": "MW",
    "mask": "#-####-####",
    "pa": 1
  },
  {
    "name": "Malaysia",
    "code": "60",
    "iso": "MY",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Maldives",
    "code": "960",
    "iso": "MV",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Mali",
    "code": "223",
    "iso": "ML",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Malta",
    "code": "356",
    "iso": "MT",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Marshall Islands",
    "code": "692",
    "iso": "MH",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Martinique",
    "code": "596",
    "iso": "MQ",
    "mask": "(###) ##-##-##",
    "pa": 3
  },
  {
    "name": "Mauritania",
    "code": "222",
    "iso": "MR",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Mauritius",
    "code": "230",
    "iso": "MU",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Mayotte",
    "code": "262",
    "iso": "YT",
    "mask": "#####-####",
    "pa": 5
  },
  {
    "name": "Mexico",
    "code": "52",
    "iso": "MX",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "code": "691",
    "iso": "FM",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Moldova",
    "code": "373",
    "iso": "MD",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Monaco",
    "code": "377",
    "iso": "MC",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Mongolia",
    "code": "976",
    "iso": "MN",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Montenegro",
    "code": "382",
    "iso": "ME",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Montserrat",
    "code": "1",
    "iso": "MS",
    "mask": "(664) ###-####",
    "pa": 3
  },
  {
    "name": "Morocco",
    "code": "212",
    "iso": "MA",
    "mask": "##-####-###",
    "pa": 2
  },
  {
    "name": "Mozambique",
    "code": "258",
    "iso": "MZ",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Myanmar",
    "code": "95",
    "iso": "MM",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Namibia",
    "code": "264",
    "iso": "NA",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Nauru",
    "code": "674",
    "iso": "NR",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Nepal",
    "code": "977",
    "iso": "NP",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Netherlands",
    "code": "31",
    "iso": "NL",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "New Caledonia",
    "code": "687",
    "iso": "NC",
    "mask": "##-####",
    "pa": 2
  },
  {
    "name": "New Zealand",
    "code": "64",
    "iso": "NZ",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Nicaragua",
    "code": "505",
    "iso": "NI",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Niger",
    "code": "227",
    "iso": "NE",
    "mask": "##-##-####",
    "pa": 2
  },
  {
    "name": "Nigeria",
    "code": "234",
    "iso": "NG",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Niue",
    "code": "683",
    "iso": "NU",
    "mask": "####",
    "pa": 1
  },
  {
    "name": "Norfolk Island",
    "code": "672",
    "iso": "NF",
    "mask": "3##-###",
    "pa": 3
  },
  {
    "name": "North Macedonia",
    "code": "389",
    "iso": "MK",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Northern Mariana Islands",
    "code": "1",
    "iso": "MP",
    "mask": "(670) ###-####",
    "pa": 3
  },
  {
    "name": "Norway",
    "code": "47",
    "iso": "NO",
    "mask": "(###) ##-###",
    "pa": 3
  },
  {
    "name": "Oman",
    "code": "968",
    "iso": "OM",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Pakistan",
    "code": "92",
    "iso": "PK",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Palau",
    "code": "680",
    "iso": "PW",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Palestine",
    "code": "970",
    "iso": "PS",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Panama",
    "code": "507",
    "iso": "PA",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Papua New Guinea",
    "code": "675",
    "iso": "PG",
    "mask": "(###) ##-###",
    "pa": 3
  },
  {
    "name": "Paraguay",
    "code": "595",
    "iso": "PY",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Peru",
    "code": "51",
    "iso": "PE",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Philippines",
    "code": "63",
    "iso": "PH",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Pitcairn",
    "code": "870",
    "iso": "PN",
    "mask": "###-###-###",
    "pa": 3
  },
  {
    "name": "Poland",
    "code": "48",
    "iso": "PL",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Portugal",
    "code": "351",
    "iso": "PT",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Puerto Rico",
    "code": "1",
    "iso": "PR",
    "mask": "(###) ### ####",
    "pa": 3
  },
  {
    "name": "Qatar",
    "code": "974",
    "iso": "QA",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Reunion",
    "code": "262",
    "iso": "RE",
    "mask": "#####-####",
    "pa": 5
  },
  {
    "name": "Romania",
    "code": "40",
    "iso": "RO",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Russia",
    "code": "7",
    "iso": "RU",
    "mask": "(###) ###-##-##",
    "pa": 3
  },
  {
    "name": "Rwanda",
    "code": "250",
    "iso": "RW",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Saint Barthelemy",
    "code": "590",
    "iso": "BL",
    "mask": "###-##-##-##",
    "pa": 3
  },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "code": "290",
    "iso": "SH",
    "mask": "####",
    "pa": 1
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "1",
    "iso": "KN",
    "mask": "(869) ###-####",
    "pa": 3
  },
  {
    "name": "Saint Lucia",
    "code": "1",
    "iso": "LC",
    "mask": "(758) ###-####",
    "pa": 3
  },
  {
    "name": "Saint Martin",
    "code": "590",
    "iso": "MF",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "508",
    "iso": "PM",
    "mask": "##-####",
    "pa": 2
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "1",
    "iso": "VC",
    "mask": "(784) ###-####",
    "pa": 3
  },
  {
    "name": "Samoa",
    "code": "685",
    "iso": "WS",
    "mask": "##-####",
    "pa": 2
  },
  {
    "name": "San Marino",
    "code": "378",
    "iso": "SM",
    "mask": "####-######",
    "pa": 4
  },
  {
    "name": "Sao Tome and Principe",
    "code": "239",
    "iso": "ST",
    "mask": "##-#####",
    "pa": 2
  },
  {
    "name": "Saudi Arabia",
    "code": "966",
    "iso": "SA",
    "mask": "##-####-####",
    "pa": 2
  },
  {
    "name": "Senegal",
    "code": "221",
    "iso": "SN",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Serbia",
    "code": "381",
    "iso": "RS",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Seychelles",
    "code": "248",
    "iso": "SC",
    "mask": "#-###-###",
    "pa": 1
  },
  {
    "name": "Sierra Leone",
    "code": "232",
    "iso": "SL",
    "mask": "##-######",
    "pa": 2
  },
  {
    "name": "Singapore",
    "code": "65",
    "iso": "SG",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Sint Maarten",
    "code": "1",
    "iso": "SX",
    "mask": "(721) ###-####",
    "pa": 3
  },
  {
    "name": "Slovakia",
    "code": "421",
    "iso": "SK",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Slovenia",
    "code": "386",
    "iso": "SI",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Solomon Islands",
    "code": "677",
    "iso": "SB",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Somalia",
    "code": "252",
    "iso": "SO",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "South Africa",
    "code": "27",
    "iso": "ZA",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "code": "500",
    "iso": "GS",
    "mask": "#####",
    "pa": 1
  },
  {
    "name": "South Sudan",
    "code": "211",
    "iso": "SS",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Spain",
    "code": "34",
    "iso": "ES",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Sri Lanka",
    "code": "94",
    "iso": "LK",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Sudan",
    "code": "249",
    "iso": "SD",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Suriname",
    "code": "597",
    "iso": "SR",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Svalbard and Jan Mayen",
    "code": "47",
    "iso": "SJ",
    "mask": "(###) ##-###",
    "pa": 3
  },
  {
    "name": "Sweden",
    "code": "46",
    "iso": "SE",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Switzerland",
    "code": "41",
    "iso": "CH",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Syrian Arab Republic",
    "code": "963",
    "iso": "SY",
    "mask": "##-####-###",
    "pa": 2
  },
  {
    "name": "Taiwan",
    "code": "886",
    "iso": "TW",
    "mask": "####-####",
    "pa": 4
  },
  {
    "name": "Tajikistan",
    "code": "992",
    "iso": "TJ",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "code": "255",
    "iso": "TZ",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Thailand",
    "code": "66",
    "iso": "TH",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Timor-Leste",
    "code": "670",
    "iso": "TL",
    "mask": "###-####",
    "pa": 3
  },
  {
    "name": "Togo",
    "code": "228",
    "iso": "TG",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Tokelau",
    "code": "690",
    "iso": "TK",
    "mask": "####",
    "pa": 1
  },
  {
    "name": "Tonga",
    "code": "676",
    "iso": "TO",
    "mask": "#####",
    "pa": 1
  },
  {
    "name": "Trinidad and Tobago",
    "code": "1",
    "iso": "TT",
    "mask": "(868) ###-####",
    "pa": 3
  },
  {
    "name": "Tunisia",
    "code": "216",
    "iso": "TN",
    "mask": "##-###-###",
    "pa": 2
  },
  {
    "name": "Turkey",
    "code": "90",
    "iso": "TR",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Turkmenistan",
    "code": "993",
    "iso": "TM",
    "mask": "#-###-####",
    "pa": 1
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "1",
    "iso": "TC",
    "mask": "(249) ###-###",
    "pa": 3
  },
  {
    "name": "Tuvalu",
    "code": "688",
    "iso": "TV",
    "mask": "######",
    "pa": 1
  },
  {
    "name": "Uganda",
    "code": "256",
    "iso": "UG",
    "mask": "(###) ###-###",
    "pa": 3
  },
  {
    "name": "Ukraine",
    "code": "380",
    "iso": "UA",
    "mask": "(##) ###-##-##",
    "pa": 2
  },
  {
    "name": "United Arab Emirates",
    "code": "971",
    "iso": "AE",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "United Kingdom",
    "code": "44",
    "iso": "GB",
    "mask": "##-####-####",
    "pa": 2
  },
  {
    "name": "United States",
    "code": "1",
    "iso": "US",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Uruguay",
    "code": "598",
    "iso": "UY",
    "mask": "#-###-##-##",
    "pa": 1
  },
  {
    "name": "Uzbekistan",
    "code": "998",
    "iso": "UZ",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Vanuatu",
    "code": "678",
    "iso": "VU",
    "mask": "##-#####",
    "pa": 2
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "code": "58",
    "iso": "VE",
    "mask": "(###) ###-####",
    "pa": 3
  },
  {
    "name": "Vietnam",
    "code": "84",
    "iso": "VN",
    "mask": "(###) ####-###",
    "pa": 3
  },
  {
    "name": "Virgin Islands, British",
    "code": "1",
    "iso": "VG",
    "mask": "(284) ###-####",
    "pa": 3
  },
  {
    "name": "Virgin Islands, U.S.",
    "code": "1",
    "iso": "VI",
    "mask": "(340) ###-####",
    "pa": 3
  },
  {
    "name": "Wallis and Futuna",
    "code": "681",
    "iso": "WF",
    "mask": "##-####",
    "pa": 2
  },
  {
    "name": "Yemen",
    "code": "967",
    "iso": "YE",
    "mask": "###-###-###",
    "pa": 3
  },
  {
    "name": "Zambia",
    "code": "260",
    "iso": "ZM",
    "mask": "##-###-####",
    "pa": 2
  },
  {
    "name": "Zimbabwe",
    "code": "263",
    "iso": "ZW",
    "mask": "#-######",
    "pa": 1
  }
]

export function countryByISO(iso: string) {
  for (const country of COUNTRIES) {
    if (country.iso === iso) {
      return country
    }
  }

  return undefined
}
